/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `TB` - Tuberculosis
 * * `FLU` - Flu
 * * `COVID19` - COVID-19
 * * `OTHER` - Other
 * * `IMMUNIZATIONS` - Immunizations
 */
export enum ImmunizationTypeEnum {
    TB = 'TB',
    FLU = 'FLU',
    COVID19 = 'COVID19',
    OTHER = 'OTHER',
    IMMUNIZATIONS = 'IMMUNIZATIONS',
}
